export default function About() {
  return (
    <section id="about" className="py-16 md:py-24 bg-white">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-bold font-serif text-foreground-950 mb-3">
              关于我们
            </h2>
            <p className="text-sm text-foreground-500">了解苹果视频的故事与使命</p>
          </div>
          <div className="rounded-2xl bg-background-50 border border-background-200/70 p-8 md:p-10">
            <div className="flex flex-col md:flex-row gap-8 items-start">
              <div className="flex-shrink-0">
                <div className="w-16 h-16 rounded-2xl bg-primary-500 flex items-center justify-center">
                  <i className="ri-play-circle-fill text-white text-3xl"></i>
                </div>
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-semibold text-foreground-950 mb-4 font-serif">
                  苹果视频 — 让每个人都能免费看好片
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                  苹果视频成立于2020年，是一家专注于免费高清影视资源的在线平台。我们致力于聚合久久视频、芒果视频、97视频、丝瓜视频等全网热门影视内容，为观众提供一站式的免费观影体验。
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                  平台目前已收录超过50000部高清电影和电视剧资源，涵盖动作、爱情、喜剧、悬疑、科幻、古装、动漫等全品类内容。我们的编辑团队每天持续更新200+资源，确保用户始终能够看到最新最热的影视作品。
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  苹果视频坚持"免费、高清、无广告"的核心理念，全站无需注册登录，即点即看。采用先进的CDN智能加速技术，无论用户身在何处，都能享受流畅不缓冲的观影体验。
                </p>
                <div className="flex flex-wrap gap-8 pt-4 border-t border-background-200">
                  <div>
                    <div className="text-2xl font-bold text-primary-500 font-serif">50000+</div>
                    <div className="text-xs text-foreground-500 mt-1">高清片源</div>
                  </div>
                  <div>
                    <div className="text-2xl font-bold text-accent-500 font-serif">200+/天</div>
                    <div className="text-xs text-foreground-500 mt-1">每日更新</div>
                  </div>
                  <div>
                    <div className="text-2xl font-bold text-secondary-500 font-serif">100万+</div>
                    <div className="text-xs text-foreground-500 mt-1">月活用户</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}